export default "/images/vendor/flag-icon-css/flags/4x3/pe.svg?9412c8bf3459213d3b45844e0e0d5ce9";